<template>
  <div class="buy-number-content-spinner-container">
    <div class="buy-number-content-spinner">
      <div class="progress-ring">
        <svg class="progress-ring__circle" viewBox="0 0 100 100">
          <circle 
            class="progress-ring__circle-bg" 
            cx="50" 
            cy="50" 
            r="40" 
            stroke="#ef851280" 
            stroke-width="10" 
            fill="transparent"
          />
          <circle 
            ref="progressCircle" 
            cx="50" 
            cy="50" 
            r="40" 
            stroke="#ef8512" 
            stroke-width="10" 
            fill="transparent" 
            stroke-dasharray="251.2" 
            :stroke-dashoffset="dashOffset"
            :style="{ opacity: circleOpacity }"
          />
        </svg>
        <img src="/img/png/notification/logo-green.png" alt="Icon" class="buy-number-img">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dashOffset: 251.2,
      circleOpacity: 1,
      animationStartTime: null,
      animationFrameId: null,
      totalDuration: 15000,
      fillDuration: 13500,
      fadeDuration: 1500
    };
  },
  mounted() {
    this.startAnimation();
  },
  beforeDestroy() {
    this.stopAnimation();
  },
  methods: {
    startAnimation() {
      this.animationStartTime = null;
      this.animationFrameId = requestAnimationFrame(this.animate);
    },
    stopAnimation() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
    animate(timestamp) {
      if (!this.animationStartTime) {
        this.animationStartTime = timestamp;
      }

      const elapsed = timestamp - this.animationStartTime;
      const cycleTime = elapsed % this.totalDuration;

      if (cycleTime <= this.fillDuration) {
        const progress = cycleTime / this.fillDuration;
        this.dashOffset = 251.2 * (1 - progress);
        this.circleOpacity = 1;
      } else {
        const fadeProgress = (cycleTime - this.fillDuration) / this.fadeDuration;
        this.circleOpacity = 1 - fadeProgress;
      }

      this.animationFrameId = requestAnimationFrame(this.animate);
    }
  }
};
</script>

<style scoped>
.buy-number-content-spinner-container {
  display: flex;
  justify-content: center;
}

.buy-number-content-spinner {
  position: relative;
  width: 150px;
  height: 150px;
  margin-top: 3rem;
}

.progress-ring {
  position: relative;
  width: 100%;
  height: 100%;
}

.progress-ring__circle {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.buy-number-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 108px;
  height: 108px;
}
</style>